/** Rough input-token estimate for prompt text (matches rules API discover logging). */
export function estimateLlmInputTokens(promptText: string): number {
  const chars = promptText.trim().length;
  if (chars === 0) return 0;
  return Math.max(1, Math.floor(chars / 4));
}

/** Compact thousands label for global-admin LLM prompt buttons, e.g. 1535 → "2KT", 56798 → "57KT". */
export function formatLlmPromptTokenKt(tokenCount: number): string {
  if (!Number.isFinite(tokenCount) || tokenCount <= 0) return "";
  const kt = Math.max(1, Math.round(tokenCount / 1000));
  return `${kt}KT`;
}

/** Button suffix after "LLM prompt", e.g. " 58KT" or " 2KT · 12.3s". */
export function buildLlmPromptButtonLabelSuffix(
  promptText: string,
  wallTimeSec?: number | null,
): string {
  const tokens = estimateLlmInputTokens(promptText);
  const kt = formatLlmPromptTokenKt(tokens);
  const ktPart = kt ? ` ${kt}` : "";
  const wallSuffix =
    wallTimeSec != null &&
    Number.isFinite(wallTimeSec) &&
    wallTimeSec >= 0
      ? `${Number(wallTimeSec.toFixed(1))}s`
      : "";
  const wallPart = wallSuffix ? ` · ${wallSuffix}` : "";
  return `${ktPart}${wallPart}`;
}
